<section class="page-hero ambassador-hero">
  <div class="hero-copy">
    <p class="eyebrow">YachtApp Ambassador Program</p>
    <h1>Help boaters run safer, better-organized vessels—and earn when they subscribe.</h1>
    <p class="lede">Introduce YachtApp to owners, captains, clubs, and marine businesses that need one calm workspace for maintenance, records, reminders, subscriptions, and operational routines.</p>
    <div class="cta-row">
      <a class="button-link" routerLink="/signup">Apply to join</a>
      <a class="button-link secondary" routerLink="/how-it-works">See how it works</a>
    </div>
  </div>
  <aside class="hero-card" aria-label="Ambassador program highlights">
    <span class="hero-card-kicker">Program snapshot</span>
    <strong>Share a practical platform for real boating workflows.</strong>
    <ul>
      <li>Dedicated referral link after approval</li>
      <li>Commission options for active partners</li>
      <li>Ready-made materials for marina, web, and social promotion</li>
    </ul>
  </aside>
</section>

<section class="content-section intro-panel">
  <div>
    <p class="eyebrow">Why YachtApp</p>
    <h2>Recommend software that solves everyday ownership pain.</h2>
  </div>
  <p>YachtApp is built for people who need clear vessel upkeep: task schedules, service history, documents, costs, and team visibility. That makes it easier to recommend naturally in conversations about maintenance, compliance, and boat readiness.</p>
</section>

<section class="content-section">
  <div class="section-heading">
    <p class="eyebrow">Ambassador advantages</p>
    <h2>What you get as an approved partner.</h2>
  </div>
  <div class="feature-grid">
    <article><span class="feature-icon">01</span><h3>Useful product fit</h3><p>Share a platform that helps customers replace scattered spreadsheets, screenshots, and paper notes with one organized digital vessel log.</p></article>
    <article><span class="feature-icon">02</span><h3>Trackable referrals</h3><p>Use approved links and campaign assets so visits, eligible signups, and paid subscriptions can be attributed clearly.</p></article>
    <article><span class="feature-icon">03</span><h3>Recurring upside</h3><p>Commission plans can reward long-term customer relationships while referred subscriptions remain active and eligible.</p></article>
    <article><span class="feature-icon">04</span><h3>Sales materials included</h3><p>Access promo codes, QR codes, flyers, screenshots, and social assets so you can promote YachtApp without starting from a blank page.</p></article>
  </div>
</section>

<section class="content-section split-section">
  <div>
    <p class="eyebrow">Who should join</p>
    <h2>Made for people already trusted by boaters.</h2>
    <p>Marine professionals, sailing communities, content creators, clubs, schools, brokers, mechanics, electricians, surveyors, and equipment shops can apply. Individuals are welcome when they have an authentic boating audience or customer relationship.</p>
  </div>
  <a class="button-link secondary" routerLink="/who-should-join">Explore partner types</a>
</section>

<section class="content-section earnings-section">
  <div class="section-heading">
    <p class="eyebrow">Commissions</p>
    <h2>Simple earning paths with room to grow.</h2>
    <p>Final terms depend on the approved plan, subscription value, customer retention, and campaign volume. Example plans start around first-year commission and can move to recurring or custom terms for high-volume partners.</p>
  </div>
  <div class="example-card"><strong>Example:</strong> Refer 10 Professional customers at $49/month with a 35% recurring commission, and eligible active subscriptions can create meaningful monthly partner income while those customers stay subscribed.</div>
</section>

<section class="content-section testimonial-card">
  <p class="eyebrow">Partner stories</p>
  <h2>Built for long-term, trusted recommendations.</h2>
  <p>Ambassador stories and partner results will be added as the program grows. For now, the program is focused on clear terms, practical materials, and a product that helps real boating operations.</p>
</section>

<section class="content-section faq-teaser">
  <div>
    <p class="eyebrow">Need details?</p>
    <h2>Review payment, attribution, and promotion rules.</h2>
    <p>Payments, worldwide promotion, individuals, minimum payouts, refunds, referral validity, and attribution rules are covered on the FAQ page.</p>
  </div>
  <a class="button-link secondary" routerLink="/faq">Read FAQ</a>
</section>

<section class="content-section join-panel">
  <p class="eyebrow">Join now</p>
  <h2>Apply today and get ready to share YachtApp.</h2>
  <p>Create your ambassador account, complete review, and receive your referral tools after approval.</p>
  <a class="button-link" routerLink="/signup">Register as an ambassador</a>
</section>
